export enum PlanogramStatusType
{
    'INITIALIZING',
    'LOADED',
    'GENERATING',
    'READY',
    'ERROR_ENCOUNTERED'
}

export class PlanogramStatus  {
    state : PlanogramStatusType = PlanogramStatusType.INITIALIZING;
    lastUpdated: Date | null = null;
    errorMessage: string = '';
}